import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Modal, 
  Popconfirm, Breadcrumb, Upload, Select, Form, Cascader, TreeSelect, 
  FormInstance, Space, Dropdown, Menu, Empty,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import copy from "copy-to-clipboard";
import { RootStoreModel } from "../../redux/reducers";
import { Unsubscribe } from "redux";
import { Link, RouteComponentProps } from "react-router-dom";
// import { Columns } from "./utils";
import { ColumnModel, BasicStateForListModel } from "../models";
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import {
  getSignContent,
  getSignContentList,
  deleteSignContent,
  uploadSignContent
} from "../../axios/api.sign";
import { 
  UploadOutlined, PlusOutlined, CheckCircleFilled, StopFilled, DownOutlined, FileDoneOutlined
} from "@ant-design/icons";
import { gaEvent } from "../../withTracker"
import { v4 as uuidv4 } from "uuid";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import { getTagList } from "@axios/api.account";
import { TagProps } from "@axios/models";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  isMultiple: boolean;
  title: string;
  file: any;
  fileList: any[];
  status: "Active" | "Disabled";
  search: string;
  id: string;
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  selectId: string,
  maxCount: number,
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class SignContentListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      isMultiple: false,
      title: "",
      file: "",
      fileList: [],
      status: "Active",
      search: "",
      id: "",
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      selectId: "",
      maxCount: 9,
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
    this.getTasks();
  }

  componentDidUpdate(prevProps: propsModel) {
  }

  componentWillUnmount() {
    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };
  getTasks = () => {
    getTagList().then((res) => {
      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getSignContentList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    }, () => {
      this.setState({
        loading: false,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteSignContent(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    const { id, title, file, status, fileList, isMultiple } = this.state;
    var count = 0;
    if (fileList.length === 0) {
      return notification.error({message: <Translation>{t => {return t("多媒体不能为空")}}</Translation>})
    }
    this.setState({ loading: true });
    fileList.forEach((item: any) => {
      uploadSignContent({
        id: id,
        title: isMultiple ? item.name.split(".")[0] : title,
        file: item.notChangeFile ? file : item,
        status: status,
      }).then(
        () => {
          notification.success({ message: <Translation>{t => {return `[${isMultiple ? item.name : title}] ${t("提交成功")}!`}}</Translation> });
          count++;
          if (count === fileList.length) {
            this.setState({ 
              loading: false, 
              id: "",
              title: "", 
              file: "", 
              fileList: [],
              status: "Active", 
              isModalVisible: false, 
              isMultiple: false 
            });
            this.getList(1);
          }
        }).finally(() => {
          !isMultiple && this.state.loading && this.setState({loading: false});
        })
    });
  };

  uploadFile = (res: any) => {
    console.log(res);
    // const { fileList } = res;
    // this.setState({ file: fileList[0].originFileObj });
    if (this.state.isMultiple) {
      var files: any[] = [];
      res.fileList.forEach((item: any) => {
        files.push(item.originFileObj);
      });
      this.setState({fileList: files});
    }
    else {
      this.setState({fileList: [res.fileList[0].originFileObj]});
    }
  };

  onEdit = (item: any) => {
    const { id, title, status } = item;
    this.setState({
      isModalVisible: true,
      id: id,
      title: title,
      status: status,
      fileList: [{name: title, notChangeFile: true}]
    });
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      isMultiple: false,
      id: "",
      title: "",
      file: "",
      status: "Active"
    });
  };

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      isMultiple,
      title,
      status,
      search,
      id,
      appTypeVisible,
      applyPeople,
      tags,
      maxCount
    } = this.state;
    const { orgOptions } = this.props;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("标牌内容")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("多媒体库")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/contentdocumentIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("多媒体库")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                      <Col>
                        {t("多媒体标题")}:
                        <Input
                          placeholder={t("输入多媒体标题搜索")}
                          style={{ width: "200px", marginLeft: 10 }}
                          value={search}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>

                      <Col offset={1}>
                        <Button type="primary" onClick={() => { this.onSearch(); gaEvent("docs", "onClick", "onSearch") }}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{marginBottom: 8}}>
                      <Col className="ms-auto">
                        <Space>
                          {/* <Button>{t("新建目录")}</Button> */}
                          <Dropdown
                            trigger={['click']}
                            dropdownRender={() => (
                              <Menu>
                                <Menu.Item key={1} onClick={() => { this.setState({ isModalVisible: true }); gaEvent("docs", "onClick", "上传多媒体") }}>{t("上传多媒体")}</Menu.Item>
                                <Menu.Item key={2} onClick={() => { this.setState({ isMultiple: true }); gaEvent("docs", "onClick", "批量上传") }}>{t("批量上传")}</Menu.Item>
                              </Menu>
                            )}
                          >
                            <Button type="primary">{t("上传")} <DownOutlined /></Button>
                          </Dropdown>
                        </Space>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => { }}
                      rowKey={record => record.id}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column 
                        key="title" 
                        dataIndex="title" 
                        title={t("多媒体标题")}
                        render={(v) => {
                          return (<>
                            <Space className="space-width-auto">
                              <FileDoneOutlined style={{display: "block"}}/>
                              <span>{v}</span>
                            </Space>
                          </>)
                        }}
                      ></Column>
                      <Column
                        key="url"
                        dataIndex="url"
                        title={t("多媒体内容")}
                        render={(v) => (
                          <Button href={v} type="link" size="small">{t("下载")}</Button>
                        )}
                      ></Column>
                      <Column
                        key="status"
                        dataIndex="status"
                        title={t("状态")}
                        render={(v) => (
                          <> 
                            {v=="Active"&&(
                              <span><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                            {v=="Disabled"&&(
                              <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                          </>
                        )}
                      ></Column>
                      <Column
                        key="updateTime"
                        dataIndex="updateTime"
                        title={t("更新时间")}
                      // render={(v) => v?.slice(10)}
                      ></Column>

                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button type="link" size="small" onClick={() => { this.onEdit(d); gaEvent("docs", "onClick", "onEdit") }}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除多媒体")} ${d.title}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                <Button type="link" size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                            </Space>
                          );
                        }}
                      ></Column>
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                maskClosable={false}
                title={id ? t("编辑多媒体") : t("上传多媒体")}
                destroyOnClose={true}
                confirmLoading={loading}
                open={isModalVisible}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <label htmlFor="">{t("多媒体标题")}</label>
                    <div>
                      <Input
                        placeholder={t("多媒体标题")}
                        value={title}
                        onChange={(e) => this.setState({ title: e.target.value })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor="">{t("多媒体")}</label>
                    <div>
                      <Upload
                        accept=".jpg,.png,.mp4"
                        listType="text"
                        showUploadList={true}
                        beforeUpload={() => {
                          return false;
                        }}
                        maxCount={1}
                        onChange={this.uploadFile}
                      >
                        <Button icon={<UploadOutlined />}>+ {t("点击上传")} </Button>
                      </Upload>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor="">{t("状态")}</label>
                    <div>
                      <Select
                        value={status}
                        onChange={(v) => this.setState({ status: v as any })}
                      >
                        <Select.Option value="Active"> {t("正常")}</Select.Option>
                        <Select.Option value="Disabled"> {t("禁用")}</Select.Option>
                      </Select>
                    </div>
                  </Col>
                </Row>
              </Modal>
              <Modal
                maskClosable={false}
                title={t("批量上传")}
                destroyOnClose={true}
                confirmLoading={loading}
                open={isMultiple}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <label htmlFor="">{t("多媒体")}</label>
                    <div>
                      <Upload
                        accept=".jpg,.png,.mp4"
                        listType="text"
                        showUploadList={true}
                        beforeUpload={() => { return false; }}
                        maxCount={maxCount}
                        onChange={this.uploadFile}
                        multiple
                      >
                        <Button icon={<UploadOutlined />}>{t("点击上传")} </Button>
                      </Upload>
                    </div>
                  </Col>
                </Row>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(SignContentListPage);
